var map = {
	"./arrow-right-to-bracket-outline.svg": 90882,
	"./arrow-up-right.svg": 14750,
	"./edit.svg": 77880,
	"./export.svg": 51830,
	"./file-copy-outline.svg": 5517,
	"./folder-plus-outline.svg": 50660,
	"./import.svg": 7899,
	"./trash.svg": 63906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9284;